/* DASHBOARD ROUTER */

import Dashboard from '@/views/dashboard/dashboard.vue';
import OneviewDashboard from '@/views/dashboard/oneviewDashboard.vue';
import BasicNoSideMenu from '@/views/layouts/basicNoSideMenu.vue';

/* ROUTER
-------------------------------------------------------------- */
const dashboardRouter = {
  path: 'dashboard',
  name: 'dashboard',
  meta: {title: 'dashboard'},
  redirect: 'dashboard/oneviewDashboard',
  component: Dashboard,
  children: [
    {
      path: 'oneviewDashboard',
      name: 'oneviewDashboard',
      meta: {title: 'Dashboard'},
      component: OneviewDashboard,
    },
  ],
};

export default dashboardRouter;
